import {clusterFaceSize, faceCluster} from '../faceCluster';
import {Avatar} from './avatar';

type Face = {photo: string | null; name: string};

// An option's face: initials, one person's photo, or a tilted cluster of several.
export const FaceCluster = ({
    title,
    photos,
    names = [],
    size,
    max,
    maxWidth,
}: {
    title: string;
    photos: (string | null)[];
    names?: string[];
    size: number;
    max?: number;
    maxWidth?: number;
}) => {
    const faces: Face[] = photos.map((photo, i) => ({photo, name: names[i] ?? title}));
    const spec = faceCluster(faces, max);
    const [first] = spec.faces;

    if (!first) {
        return <Avatar name={title} size={size} shape="square" />;
    }
    if (spec.kind === 'single') {
        return <Avatar src={first.photo ?? undefined} name={first.name} size={size} />;
    }

    const face = clusterFaceSize(size, spec, maxWidth);
    return (
        <span
            className="sd-cluster"
            role="img"
            aria-label={title}
            style={{'--sd-cluster-face': `${face}px`} as React.CSSProperties}
        >
            {spec.faces.map((f, index) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: faces are positional and never reorder in place
                <span key={index} className="sd-cluster__face" aria-hidden="true">
                    <Avatar src={f.photo ?? undefined} name={f.name} size={face} />
                </span>
            ))}
            {spec.overflow > 0 && (
                <span className="sd-cluster__more" aria-hidden="true">
                    +{spec.overflow}
                </span>
            )}
        </span>
    );
};
